import { render } from "./NewsImage.vue?vue&type=template&id=4a270207"
import script from "./NewsImage.vue?vue&type=script&lang=js"
export * from "./NewsImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__